import axios from "axios";
import { siteUrl } from "../clases/constans";

const API_BASE_URL = "https://api.viaq.ir/secret";
let isApiCalled = false;

/**
 * Perform a POST request to the specified path with the provided data.
 * @param {string} path - The API endpoint path.
 * @param {object} data - The data to be sent in the request body.
 * @returns {object} - The response from the server.
 */

const postRequest = async (path, data) => {
  try {
    const url = `${API_BASE_URL}/${path}`;

    const response = await axios.post(url, data);
    // console.log("RESPONSE : ",response);
    if (response.status !== 200) {
      return {
        status: {
          code: 0,
          message: "عدم ارتباط با سرور",
        },
      };
    }

    return response.data;
  } catch (error) {
    return {
      status: {
        code: 0,
        message: "عدم ارتباط با سرور",
      },
    };
  }
};

let res = false;

/**
 * Refresh the access token using the refresh token.
 * @param {string} url - The endpoint for refreshing the token.
 * @param {object} data - The data required for token refresh.
 * @param {string} method - The HTTP method for the request (default is "post").
 * @returns {object} - The response from the server.
 */

const refreshToken = async (url, data, method = "post") => {
  const refreshToken = localStorage.getItem("refreshToken");
  const token = localStorage.getItem("token");


  try {
    const response = await axios.post(
      `${API_BASE_URL}/dashboard/refresh-token`,
      { refreshToken },
      { headers: { "x-auth-token": token } }
    );



    if (response.status !== 200) {
      return {
        status: {
          code: 0,
          message: "عدم ارتباط با سرور",
        },
      };
    }

    if (response.status === 404) {
      return window.location.replace(`${siteUrl}/404`);
    }
   
    if (response.data.status.code !== 1) {
  
      localStorage.removeItem("token");
      localStorage.removeItem("refreshToken");

      setTimeout(() => {
        // console.log("Returning to the main page...");
        window.location.replace(siteUrl);
      }, 1000);

      return {
        status: {
          code: 0,
          message: "عدم ارتباط با سرور",
        },
      };
    }

    localStorage.setItem("token", response.data.data.accessToken);
    localStorage.setItem("refreshToken", response.data.data.refreshToken);

    if (method === "post") return postRequestWithToken(url, data, (res = true));

    return getRequestWithToken(url);
  } catch (error) {

    return {
      status: {
        code: 0,
        message: "عدم ارتباط با سرور",
      },
    };
  }
};

/**
 * Perform a POST request to the specified path with the provided data and access token.
 * @param {string} url - The API endpoint path.
 * @param {object} data - The data to be sent in the request body.
 * @param {boolean} res - A flag indicating whether the response includes "res" property.
 * @returns {object} - The response from the server.
 */
const postRequestWithToken = async (url, data, res) => {
  try {
 
    const token = localStorage.getItem("token");
    const response = await axios.post(`${API_BASE_URL}${url}`, data, {
      headers: { "x-auth-token": token },
    });


    if (response.status !== 200) {
   
      return {
        status: {
          code: 0,
          message: "عدم ارتباط با سرور",
        },
      };
    }

    if (response.status === 404) {
     
      return window.location.replace(siteUrl);
    }

    if (response.data.status.code === -3) {
      return refreshToken(url, data);
    }

    response.data.response = res;
    return response.data;
  } catch (error) {
    return {
      status: {
        code: 0,
        message: "عدم ارتباط با سرور",
      },
    };
  }
};

/**
 * Perform a GET request to the specified path with the access token.
 * @param {string} url - The API endpoint path.
 * @returns {object} - The response from the server.
 */
const getRequestWithToken = async (url) => {
  try {
    const token = localStorage.getItem("token");

    const response = await axios.get(`${API_BASE_URL}/${url}`, {
      headers: { "x-auth-token": token },
    });


    if (response.status !== 200) {
      return {
        status: {
          code: 0,
          message: "عدم ارتباط با سرور",
        },
      };
    }

    if (response.status === 404) {
      isApiCalled = false;
      return window.location.replace(siteUrl);
    }

    if (response.data.status.code === -3) {
      return refreshToken(url, {}, "get");
    }

    return response.data;
  } catch (error) {
    return {
      status: {
        code: 0,
        message: "عدم ارتباط با سرور",
      },
    };
  }
};

/**
 * Download a file from the specified path with the given filename using the access token.
 * @param {string} url - The API endpoint path for downloading the file.
 * @param {string} fileName - The desired filename for the downloaded file.
 * @param {object} data - Additional data required for the download (if any).
 * @returns {boolean} - Indicates whether the download was successful.
 */
const axiosDownloadFile = async (url, fileName, data) => {
  const token = localStorage.getItem("token");

  try {
    const response = await axios({
      url: `${API_BASE_URL}${url}`,
      headers: { "x-auth-token": token },
      method: "POST",
    });


    var reader = new window.FileReader();

    const buffer = Buffer.from(response.data, "base64");
    reader.readAsDataURL(
      new Blob([buffer], { type: "application/octet-stream" })
    );

    reader.onload = function () {
      const anchorElement = document.createElement("a");

      anchorElement.href = reader.result;
      anchorElement.download = fileName;

      document.body.appendChild(anchorElement);
      anchorElement.click();

      document.body.removeChild(anchorElement);
    };

    return true;
  } catch (error) {
    return false;
  }
};

/*
export {
  postRequest,
  postRequestWithToken,
  getRequestWithToken,
  axiosDownloadFile,
};
*/
export {API_BASE_URL}
